import React from 'react';
import Select from 'react-select';
const ReduxStore = require('../redux/reduxStore.jsx.js');
const AjaxFunctions = require('../ajaxFunctions.js');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const SharedConstants = require('../../../../shared/sharedConstants');

export class SearchScreen extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   render() {

      return (
         <div>
            <ReduxCondensedSearchPanel
               setScreenToTopicFilter={() => this.props.setScreenToTopicFilter()}
               lastFilterFunction={this.props.lastFilterFunction}
            />
            <FilterScreen
               lastFilterFunction={this.props.lastFilterFunction}
               disableCardTypeFilter={this.props.disableCardTypeFilter}
               setLastFilterFunction={(func) => this.props.setLastFilterFunction(func)}
            />
         </div>
      );
   }
}

class CondensedSearchPanel extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   render() {
      return (
         <div className='side-header'>
            <div className='form-group'>
               <SearchBarInput
                  lastFilterFunction={this.props.lastFilterFunction}
                  currentSearchString={this.props.currentSearchString}
               />
            </div>
         </div>
      );
   }
}

class FilterScreen extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   render() {
      return (
         <div>
            <fieldset className='form__container'>
               <div>
                  <h1 className='form__header'>Filter &micro;Pubs&trade;</h1>
               </div>
               <div>Filter By: </div>
               {!this.props.disableCardTypeFilter && <CardTypeFilterBar
                  setLastFilterFunction={(func) => this.props.setLastFilterFunction(func)}
               />}
               <EvidenceCardFilterBar
                  setLastFilterFunction={(func) => this.props.setLastFilterFunction(func)}
               />
            </fieldset>
         </div>
      );
   }
}

class SearchBarInput extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   onSearchTextChange(event){
      document.getElementById('displayPageContainer').scrollTop = 0;
      onSearchTextChange(event);
      this.props.lastFilterFunction();

   }

   render() {
      return (
         <div className='inputGroup'>
            <div className='filter-category-header' style={{color:"white"}}>Search:</div>
            <input
               className='form-control search-text-box'
               type='text'
               placeholder={`Search for ${String.fromCharCode(181)}Pubs`}
               aria-label='Search'
               onChange={(event) => this.onSearchTextChange(event)}
               value={this.props.currentSearchString}
            />
            <i className='fa fa-search search-btn float-right' aria-hidden='true' />
         </div>
      );
   }
}

class FilterBar extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   onSelectedFiltersChanged(selectedOptions){
      this.props.setFilterArray(selectedOptions);
      this.handleFilterOperation();
   }

   handleFilterOperation(){
      doFilterOperation();
      this.props.setLastFilterFunction(doFilterOperation);
   }

   render() {

      //this is here to ensure the data is in the proper format since it has changed
      let currentValues = [];
      try {
         currentValues = this.props.currentFilterArray.map(o => {
            return {value: o.value, label: o.label}
         });
      }
      catch(err){
         console.log(err);
         this.props.clearFilter();
      }

      return (
         <div className='filter-category'>
            <div className='filter-category-header'>{this.props.header}</div>
            <Select
               closeMenuOnSelect={false}
               options={this.props.options}
               value={currentValues}
               isMulti
               onChange={(selectedOptions) => this.onSelectedFiltersChanged(selectedOptions) }
               id={'topic-search-text-input'}
            />
         </div>
      );
   }
}

const mapEvidenceCardFilterBarStateToProps = (state) => {
   let options = state.EditorReducer.allTopics.map(t => { return {value: t.idTopic, label: t.name} } );
   return {
      header: 'Topic',
      options,
      currentFilterArray: state.EditorReducer.topicFilterArray,
   }
};

const mapEvidenceCardFilterBarDispatchToProps = (dispatch) => {
   return {
      clearFilter: () => {
         dispatch(ReduxStore.EditorFunctions.clearTopicFilter());
      },
      setFilterArray: (filterArray) => {
         dispatch(ReduxStore.EditorFunctions.setTopicFilterArray(filterArray));
         dispatch(ReduxStore.EditorFunctions.clearDeckFilter());
      }
   }
};

const EvidenceCardFilterBar = connect(
   mapEvidenceCardFilterBarStateToProps,
   mapEvidenceCardFilterBarDispatchToProps
)(FilterBar);

const mapCardTypeFilterBarStateToProps = (state) => {
   let options = [
      {value: SharedConstants.CardType.Evidence, label: 'Evidence'},
      {value: SharedConstants.CardType.Reasoning, label: 'Conjecture'}
   ];

   return {
      header: 'Type',
      options,
      currentFilterArray: state.EditorReducer.cardTypeFilterArray,
   }
};

const mapCardTypeFilterBarDispatchToProps = (dispatch) => {
   return {
      clearFilter: () => {
         dispatch(ReduxStore.EditorFunctions.clearCardTypeFilter());
      },
      setFilterArray: (filterArray) => {
         dispatch(ReduxStore.EditorFunctions.setCardTypeFilterArray(filterArray))
      }
   }
};

const CardTypeFilterBar = connect(
   mapCardTypeFilterBarStateToProps,
   mapCardTypeFilterBarDispatchToProps
)(FilterBar);

const mapCondensedSearchPanelStateToProps = (state) => {
   let topicMap = {};
   for(let topic of state.EditorReducer.allTopics){
      topicMap[topic.idTopic] = topic.name;
   }
   return {
      topicMap,
      currentTopicFilterArray: state.EditorReducer.topicFilterArray,
      currentSearchString: state.EditorReducer.searchString,
   }
};


const ReduxCondensedSearchPanel = connect(
   mapCondensedSearchPanelStateToProps,
   () => {}
)(CondensedSearchPanel);

function onSearchTextChange(event){
   ReduxStore.store.dispatch(ReduxStore.EditorFunctions.setSearchString(event.target.value));
}

async function doFilterOperation(startDate, shouldAppend){
   let topicFilterArray = ReduxStore.store.getState().EditorReducer.topicFilterArray;
   let cardTypeFilterArray = ReduxStore.store.getState().EditorReducer.cardTypeFilterArray;

   let filterObject = {};

   if(startDate){
      filterObject.fromDate = new Date(startDate);
   }

   if(topicFilterArray.length > 0){
      filterObject.topics = topicFilterArray.map(t => t.value);
   }

   if(cardTypeFilterArray.length > 0){
      filterObject.cardTypes = cardTypeFilterArray.map(t => t.value);
   }

   let searchString = ReduxStore.store.getState().EditorReducer.searchString;
   if(searchString.trim() !== ''){
      filterObject.searchString = searchString;
   }

   let data = await AjaxFunctions.getFilteredCardData(filterObject);

   if(shouldAppend)
      ReduxStore.appendCardData(data);
   else{
      ReduxStore.processCardData(data);
   }
}
